import { colors, size } from '@styles/theme'
import styled from '@emotion/styled'
import PostDisplay from '@components/feeds/post/PostDisplay'
import LikeDisplayByPost from './displays/LikeDisplayByPost'
import LikeDisplayByUser from './displays/LikeDisplayByUser'
import RepostDisplayByPost from './displays/RepostDisplayByPost'
import RepostDisplayByUser from './displays/RepostDisplayByUser'
import FollowDisplay from './displays/FollowDisplay'


const NotificationContainer = styled.div``

const POST_DISPLAY = new Set(['reply', 'mention'])

const Notification = ({ displayNotification, setLikeToState, setUnlikeToState, setRepostToState, newReplyAfterCreate, openPosts, index }) => {

  const renderContents = () => {
    const { post, action, data, groupedBy, format } = displayNotification
    if (POST_DISPLAY.has(action)) {
      return (
        <PostDisplay
          post={post}
          user={post.user}
          isRepost={false}
          isRepliedTo={false}
          isReplier={post?.isReply}
          beforeLikeHook={setLikeToState}
          beforeUnlikeHook={setUnlikeToState}
          beforeRepostHook={setRepostToState}
          newReplyAfterCreate={newReplyAfterCreate}
          index={index}
          containerStyles={{ paddingTop: size(2) }}
        />
      )
    } else if (action === 'like') {
      if (format === 'users_by_like') {
        return (
          <LikeDisplayByPost
            users={data}
            post={groupedBy}
          />
        )
      } else if (format === 'likes_by_user') {
        return (
          <LikeDisplayByUser
            openPosts={openPosts}
            user={groupedBy}
            posts={data}
          />
        )
      }
    }  else if (action === 'repost') {
      if (format === 'users_by_repost') {
        return (
          <RepostDisplayByPost
            users={data}
            post={groupedBy}
          />
        )
      } else if (format === 'reposts_by_user') {
        return (
          <RepostDisplayByUser
            openPosts={openPosts}
            user={groupedBy}
            posts={data}
          />
        )
      }
    } else if (action === 'follow') {
      return (
        <FollowDisplay users={data} />
      )
    }
  }

  const coloredBackgroundStyles = () => ({
    backgroundColor: !displayNotification?.seenAt
      && colors.statusColors.right_now('primary') + '20',
  })

  return (
    <NotificationContainer style={coloredBackgroundStyles()}>
      {renderContents()}
    </NotificationContainer>
  )
}

export default Notification
